import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Address } from '@amfam/policy/models';

@Component({
  selector: 'ds-garage-list',
  templateUrl: './garage-list.component.html',
  styleUrls: ['./garage-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class GarageListComponent implements OnInit {
  @Input() addressList: Address[];
  @Output() addressChange = new EventEmitter();

  form: UntypedFormGroup;
  addressCtrl: AbstractControl;

  constructor(private formBuilder: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.buildForm();
  }

  toggleAddress(address: unknown) {
    this.addressCtrl.setValue(address);
    this.addressChange.emit(this.addressCtrl.value);
  }

  private buildForm() {
    this.form = this.formBuilder.group({
      addressSelected: ['', Validators.compose([Validators.required])]
    });
    this.addressCtrl = this.form.controls['addressSelected'];
  }
}
